export default __webpack_public_path__ + "static/media/104-focus-renew.baa45dad.jpeg";